export const citiesStore = {
    list: [],
    selectedFleet: '',
};
